import { LoadingSpinner } from 'twyne-new.ui'

export default function LoadingIcon() {
  return <div className='flex h-4 items-center'>
    <LoadingSpinner width='16' heigth='16' />
  </div>
}
